module.exports = __webpack_public_path__ + "static/img/charging.cc2123a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/charging.png
// module id = Ayas
// module chunks = 1